import { AsyncPipe } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { ExportTrayComponent } from './components/export-tray/export-tray.component';
import { SidenavComponent } from "./components/sidenav/sidenav.component";
import { SessionState, SessionStore } from './services/session.store';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  imports: [RouterOutlet, SidenavComponent, ExportTrayComponent, AsyncPipe],
})
export class App {
  protected readonly title = signal('prodsee-app');

  readonly state$: Observable<SessionState>;

  constructor(private store: SessionStore) {
    this.state$ = this.store.state$;
  }
}
